import {combineReducers} from "redux"
import {
    ADD_DIALOG,
    ADD_LIST_TAB,
    ADD_TAB,
    CHANGE_LAYOUT_FILTER,
    CHANGE_LAYOUT_TABLE,
    CHANGE_LOGO_TENANT,
    CHANGE_MAIN_TAB,
    CHANGE_PHONE,
    CHANGE_STATUS,
    CHANGE_TAB_ACTIVE,
    EDIT_DIALOG,
    FETCH_LIST_ROLES,
    GET_AGAIN_DIALOG,
    MINIMIZED_DIALOG,
    PAGINATION_TAB,
    REMOVE_DIALOG,
    REMOVE_TAB,
    RESET_LIST_ROLES,
    SET_INFORMATION_CALL_SSE,
    SET_UPDATE_ZALO_PAGE,
    SORT_AGAIN_TAB,
    UPDATE_SOCKET_DATA,
    UPDATE_SSE_DATA
} from "./action"
import {getLocalData} from "../services/StorageServices"
import {
    _setLocalDataDialogs,
    _setLocalDataTabActive,
    _setLocalDataTabs,
    _setLocalDataTabsNotChange
} from "../helpers/convertArrayToObject"
import {tabComponent} from "../app/shared/Contants"

const initialState = {
    roles: [],
    logoTenant: [],
    status: getLocalData('status') || 'NOT LOGIN',
    phoneNumber: getLocalData('ipPhone') || 'N/A',
    layoutFilter: [],
    layoutTable: [],
    layoutAssignFilter: [],
    sseData: {},
    socketData: {},
    dialogs: [],
    collapseDialog: [],
    updateMessagePage: 0
}

const currentUrl = window.location.href

const pathArray = currentUrl.split('/')

const initialStateTabs = {
    tabs: [
        {
            id: tabComponent.find(item => item.type === pathArray[pathArray.length - 1])?.id || 'leadPage',
            title: tabComponent.find(item => item.type === pathArray[pathArray.length - 1])?.title || 'Quản lý lead',
            idProp: null,
            icon: ''
        },
    ],
    tabsNotChangeSort: [
        {
            id: tabComponent.find(item => item.type === pathArray[pathArray.length - 1])?.id || 'leadPage',
            title: tabComponent.find(item => item.type === pathArray[pathArray.length - 1])?.title || 'Quản lý lead',
            idProp: null,
            icon: ''
        },
    ],
    tabActive: {
        id: tabComponent.find(item => item.type === pathArray[pathArray.length - 1])?.id || 'leadPage',
        idProp: null
    },
}

const initialStateCallSSE = {
    callInformationSSE: {}
}

const rolesReducer = (state = initialState, action) => {
    const {type, payload} = action

    switch (type) {
        case FETCH_LIST_ROLES:
            return {
                ...state, roles: payload
            }
        case RESET_LIST_ROLES:
            return {
                ...state, roles: []
            }
        case CHANGE_STATUS:
            return {
                ...state, status: payload
            }
        case CHANGE_PHONE:
            return {
                ...state, phoneNumber: payload
            }
        case CHANGE_LAYOUT_FILTER:
            return {
                ...state, layoutFilter: payload
            }
        case CHANGE_LAYOUT_TABLE:
            return {
                ...state, layoutTable: payload
            }
        case CHANGE_LOGO_TENANT:
            return {
                ...state, logoTenant: payload
            }
        case UPDATE_SSE_DATA:
            if (Object.keys(payload).length > 0) {
                return {
                    ...state,
                    sseData: {
                        ...state.sseData,
                        ...payload
                    }
                }
            } else {
                return {
                    ...state,
                    sseData: {}
                }
            }
        case UPDATE_SOCKET_DATA:
            if (Object.keys(payload).length > 0) {
                return {
                    ...state,
                    socketData: {
                        ...state.socketData,
                        ...payload
                    }
                }
            } else {
                return {
                    ...state,
                    socketData: {}
                }
            }
        case ADD_DIALOG:
            const indexDialog = state.dialogs.findIndex(item => item.dlgId === payload.dlgId)
            const indexCollapse = state.collapseDialog.findIndex(item => item.dlgId === payload.dlgId)

            if (indexDialog !== -1) {
                console.log(payload)
                _setLocalDataDialogs({
                    dialogs: state.dialogs.map(item => {
                        if (item.dlgId === payload.dlgId) {
                            return {
                                ...item,
                                isNew: payload.isNew,
                                dlgRecordId: payload.dlgRecordId,
                                dlgVersion: Math.floor(Math.random() * 1000000000)
                            }
                        } else {
                            return item
                        }
                    }), collapseDialog: state.collapseDialog
                })
                return {
                    ...state, dialogs: state.dialogs.map(item => {
                        if (item.dlgId === payload.dlgId) {
                            return {
                                ...item,
                                isNew: payload.isNew,
                                dlgRecordId: payload.dlgRecordId,
                                dlgVersion: Math.floor(Math.random() * 1000000000)
                            }
                        } else {
                            return item
                        }
                    })
                }
            } else if (indexCollapse !== -1) {
                console.log('==Have2===')
                _setLocalDataDialogs({
                    // eslint-disable-next-line array-callback-return
                    dialogs: state.dialogs, collapseDialog: [...state.collapseDialog.map(item => {
                        if (item.dlgId === payload.dlgId) {
                            return {
                                ...item, isNew: '1'
                            }
                        }
                    })]
                })
                return {
                    // eslint-disable-next-line array-callback-return
                    ...state, collapseDialog: [...state.collapseDialog.map(item => {
                        if (item.dlgId === payload.dlgId) {
                            return {
                                ...item, isNew: '1'
                            }
                        }
                    })]
                }
            } else {
                if (state.dialogs.length >= 2) {
                    console.log('==Have3===')
                    const dialogZero = state.dialogs[0]
                    _setLocalDataDialogs({
                        dialogs: [...state.dialogs.slice(1), payload,],
                        collapseDialog: [dialogZero, ...state.collapseDialog]
                    })
                    return {
                        ...state,
                        dialogs: [...state.dialogs.slice(1), payload,],
                        collapseDialog: [...state.collapseDialog, dialogZero,]
                    }
                } else {
                    console.log('==Have4===')
                    _setLocalDataDialogs({
                        dialogs: [...state.dialogs, payload,], collapseDialog: state.collapseDialog
                    })
                    return {
                        ...state, dialogs: [...state.dialogs, payload,]
                    }
                }
            }
        case REMOVE_DIALOG:
            let collapseValue = null
            let newCollapseArr = []
            const anotherDialog = state.dialogs.filter(item => item.dlgId !== payload)

            if (state.collapseDialog.length > 0) {
                collapseValue = state.collapseDialog[0]
                newCollapseArr = [...state.collapseDialog.slice(1)]
            }

            _setLocalDataDialogs({
                dialogs: collapseValue !== null ? [...anotherDialog, {
                    ...collapseValue, dlgMinimized: false
                }] : anotherDialog, collapseDialog: newCollapseArr
            })

            return {
                ...state, dialogs: collapseValue !== null ? [...anotherDialog, {
                    ...collapseValue, dlgMinimized: false
                }] : anotherDialog, collapseDialog: newCollapseArr
            }
        case EDIT_DIALOG:
            let dialogValue = null
            let newDialogArr2 = []
            const collapseDialog = state.collapseDialog.filter(item => item.dlgId === payload.id)
            const anotherCollapseDialog = state.collapseDialog.filter(item => item.dlgId !== payload.id)

            dialogValue = state.dialogs[0]
            newDialogArr2 = [...state.dialogs.slice(1)]

            _setLocalDataDialogs({
                dialogs: [...newDialogArr2, {
                    ...collapseDialog[0], dlgMinimized: false
                }], collapseDialog: [...anotherCollapseDialog, dialogValue]
            })

            return {
                ...state, dialogs: [...newDialogArr2, {
                    ...collapseDialog[0], dlgMinimized: false
                }], collapseDialog: [...anotherCollapseDialog, dialogValue]
            }
        case MINIMIZED_DIALOG:
            const index = state.dialogs.findIndex(item => item.dlgId === payload.id)

            if (index !== -1) {
                state.dialogs[index].dlgMinimized = payload.minimized
                state.dialogs[index].isNew = payload.isNew
            }

            _setLocalDataDialogs({
                collapseDialog: state.collapseDialog, dialogs: state.dialogs
            })

            return {
                ...state, dialogs: state.dialogs
            }
        case GET_AGAIN_DIALOG:
            return {
                ...state, ...payload
            }
        case SET_UPDATE_ZALO_PAGE:
            return {
                ...state,
                updateMessagePage: Math.floor(Math.random() * 1000000000)
            }
        default:
            return {
                ...state
            }
    }
}

const tabsReducer = (state = initialStateTabs, action) => {
    const {type, payload} = action

    switch (type) {
        case ADD_LIST_TAB:
            return {
                ...state,
                tabs: payload,
                tabsNotChangeSort: payload
            }
        case ADD_TAB:
            const indexTabs = state.tabs.findIndex(item => item.id === payload.id)

            if (indexTabs !== -1) {
                const anotherTab = state.tabs.filter(item => item.id !== payload.id && item.id !== state.tabs[0].id)

                _setLocalDataTabs([
                    state.tabs[0],
                    {
                        id: payload.id,
                        title: payload.title,
                        idProp: payload.idLeadDetail,
                        icon: payload.icon
                    },
                    ...anotherTab
                ])
                _setLocalDataTabActive({
                    id: payload.id,
                    idProp: payload.idLeadDetail
                })
                return {
                    ...state,
                    tabs: [
                        state.tabs[0],
                        {
                            id: payload.id,
                            title: payload.title,
                            idProp: payload.idLeadDetail,
                            icon: payload.icon
                        },
                        ...anotherTab
                    ],
                    tabActive: {
                        id: payload.id,
                        idProp: payload.idLeadDetail
                    }
                }
            } else {
                _setLocalDataTabs([
                    state.tabs[0],
                    {
                        id: payload.id,
                        title: payload.title,
                        idProp: payload.idLeadDetail,
                        icon: payload.icon
                    },
                    ...state.tabs.slice(1)
                ])
                _setLocalDataTabsNotChange([
                    ...state.tabsNotChangeSort,
                    {
                        id: payload.id,
                        title: payload.title,
                        idProp: payload.idLeadDetail,
                        icon: payload.icon
                    }
                ])
                _setLocalDataTabActive({
                    id: payload.id,
                    idProp: payload.idLeadDetail
                })
                return {
                    ...state,
                    tabs: [
                        state.tabs[0],
                        {
                            id: payload.id,
                            title: payload.title,
                            idProp: payload.idLeadDetail,
                            icon: payload.icon
                        },
                        ...state.tabs.slice(1)
                    ],
                    tabsNotChangeSort: [
                        ...state.tabsNotChangeSort,
                        {
                            id: payload.id,
                            title: payload.title,
                            idProp: payload.idLeadDetail,
                            icon: payload.icon
                        }
                    ],
                    tabActive: {
                        id: payload.id,
                        idProp: payload.idLeadDetail
                    }
                }
            }
        case REMOVE_TAB:
            const anotherTab = state.tabs.filter(item => item.id !== action.payload)
            _setLocalDataTabs([...anotherTab])
            _setLocalDataTabsNotChange([...state.tabsNotChangeSort])
            return {
                ...state,
                tabs: [...anotherTab],
                tabsNotChangeSort: [...state.tabsNotChangeSort]
            };
        case CHANGE_TAB_ACTIVE:
            const filterTab = state.tabs.filter(item => item.id === payload.id)
            _setLocalDataTabActive(filterTab[0])
            return {
                ...state,
                tabActive: filterTab[0]
            }
        case PAGINATION_TAB:
            const filterAnotherTab = state.tabs.filter(item => item.id !== state.tabActive.id)
            const filterAnotherTabNotChange = state.tabsNotChangeSort.filter(item => item.id !== state.tabActive.id)

            _setLocalDataTabs([
                ...filterAnotherTab,
                payload
            ])
            _setLocalDataTabsNotChange([
                ...filterAnotherTabNotChange,
                payload
            ])
            _setLocalDataTabActive(
                {
                    id: payload.id,
                    idProp: payload.idLeadDetail
                }
            )
            return {
                ...state,
                tabs: [
                    ...filterAnotherTab,
                    payload
                ],
                tabsNotChangeSort: [
                    ...filterAnotherTabNotChange,
                    payload
                ],
                tabActive: {
                    id: payload.id,
                    idProp: payload.idLeadDetail
                }
            }
        case SORT_AGAIN_TAB:
            const tabsDep = state.tabs;
            const anotherArray = tabsDep.filter(item => item.id !== tabsDep[action.payload.index2].id)
            const insert = (arr, index, newItem) => [...arr.slice(0, index), newItem, ...arr.slice(index)]
            const newArr = insert(anotherArray, 1, tabsDep[action.payload.index2])

            _setLocalDataTabs(newArr)

            return {
                ...state,
                tabs: newArr
            }
        case CHANGE_MAIN_TAB:
            _setLocalDataTabs([
                {
                    id: payload.id,
                    title: payload.title,
                    idProp: payload.idLeadDetail,
                    icon: payload.icon
                },
                ...state.tabs.slice(1)
            ])
            _setLocalDataTabsNotChange([
                {
                    id: payload.id,
                    title: payload.title,
                    idProp: payload.idLeadDetail,
                    icon: payload.icon
                },
                ...state.tabsNotChangeSort.slice(1)
            ])
            _setLocalDataTabActive({
                id: payload.id,
                idProp: payload.idLeadDetail
            })
            return {
                ...state,
                tabs: [
                    {
                        id: payload.id,
                        title: payload.title,
                        idProp: payload.idLeadDetail,
                        icon: payload.icon
                    },
                    ...state.tabs.slice(1)
                ],
                tabsNotChangeSort: [
                    {
                        id: payload.id,
                        title: payload.title,
                        idProp: payload.idLeadDetail,
                        icon: payload.icon
                    },
                    ...state.tabsNotChangeSort.slice(1)
                ],
                tabActive: {
                    id: payload.id,
                    idProp: payload.idLeadDetail
                }
            }
        default:
            return {
                ...state
            }
    }
}

const callSSEReducer = (state = initialStateCallSSE, action) => {
    const {type, payload} = action

    switch (type) {
        case SET_INFORMATION_CALL_SSE:
            return {
                ...state,
                callInformationSSE: payload
            }
        default:
            return {
                ...state
            }
    }
}

export default combineReducers({
    rolesReducer,
    tabsReducer,
    callSSEReducer
})
